// extracted by mini-css-extract-plugin
export default {"row":"Motivation_row__vogfy","col1":"Motivation_col1__NdBf9","col2":"Motivation_col2__U7GDe","required":"Motivation_required__6E6lZ"};